import { components } from "react-select";
import { formatMilesDecimal, formatUnitMeasure } from "@/services/Utils";

import classes from "./customProductSelect.module.scss";

const truncateIngredientsText = (ingredients, maxLength = 20) => {
	const fullText = ingredients.join(" ");
	if (fullText.length <= maxLength) {
		return { text: fullText, isTruncated: false, fullText };
	}
	return { text: `${fullText.slice(0, maxLength)}...`, isTruncated: true, fullText };
};

const getStockByEstate = (item, estateId) => {
	if (!estateId || !item.stock_estates?.length) return 0;
	const match = item.stock_estates.find((estateStock) => Number(estateStock.estate_id) === Number(estateId));
	if (!match) return 0;
	return item.unit_measurement !== "u" ? match.stock / 1000 : match.stock;
};

export const CustomProductSelectOption = (props) => {
	const item = props.data;
	const isGeneric = Boolean(item.generic);
	const showActiveIngredients = props.selectProps?.showActiveIngredients ?? true;
	const showStock = props.selectProps?.showStock ?? true;
	const estateId = props.selectProps?.estateId ?? null;

	const ingredientsDisplay =
		showActiveIngredients && item.active_ingredients_list?.length > 0 ? truncateIngredientsText(item.active_ingredients_list, 20) : null;

	return (
		<components.Option {...props}>
			<div className={classes.productOptionRow}>
				<div className={classes.productOption}>
					<div className={`${classes.productBadges} ${isGeneric ? classes.badge_blue : classes.badge_green}`}>
						<span> {isGeneric ? "G" : "E"}</span>
					</div>
					<span>{item.label}</span>
				</div>

				{showActiveIngredients && (
					<div className={`${classes.productOption} ${classes.activeIngredients}`}>
						{ingredientsDisplay && (
							<span className={classes.ingredientText} title={ingredientsDisplay.isTruncated ? ingredientsDisplay.fullText : ""}>
								{ingredientsDisplay.text}
							</span>
						)}
					</div>
				)}

				{showStock && (
					<div className={classes.productOption}>
						{formatMilesDecimal(Math.max(0, getStockByEstate(item, estateId)))}
						<span className={classes.unit}>{item.unit_measurement ? formatUnitMeasure(item.unit_measurement) : ""}</span>
					</div>
				)}
			</div>
		</components.Option>
	);
};

export const CustomProductSelectSingleValue = (props) => {
	const item = props.data;
	const isGeneric = Boolean(item.generic);
	const showStock = props.selectProps?.showStock ?? true;
	const estateId = props.selectProps?.estateId ?? null;

	return (
		<components.SingleValue {...props}>
			<div className={`${classes.productOptionRow} ${classes.productOptionRowSingle}`}>
				<div className={classes.productOption}>
					<div className={`${classes.productBadges} ${isGeneric ? classes.badge_blue : classes.badge_green}`}>
						<span> {isGeneric ? "G" : "E"}</span>
					</div>
					<span>{item.label}</span>
				</div>

				{showStock && (
					<div className={classes.productOption}>
						{formatMilesDecimal(Math.max(0, getStockByEstate(item, estateId)))}
						<span className={classes.unit}>{item.unit_measurement ? formatUnitMeasure(item.unit_measurement) : ""}</span>
					</div>
				)}
			</div>
		</components.SingleValue>
	);
};

export const CustomProductSelectMenu = (props) => {
	const hasOptions = props.selectProps && props.selectProps.options && props.selectProps.options.length > 0;
	const showActiveIngredients = props.selectProps?.showActiveIngredients ?? true;
	const showStock = props.selectProps?.showStock ?? true;

	return (
		<components.Menu {...props}>
			<div className={classes.productOptionTable}>
				{hasOptions && (
					<div className={classes.productOptionHeader}>
						<span>NOMBRE COMERCIAL</span>
						{showActiveIngredients && <span>INGREDIENTE ACTIVO</span>}
						{showStock && <span>STOCK</span>}
					</div>
				)}
				{props.children}
			</div>
		</components.Menu>
	);
};
